import { Box } from "@mui/material";
import ThemeContext from "components/app/Context";
import { useContext } from "react";
import { useAppSelector } from "redux/hooks";
import colors from "styles/Colors";
import { accessTypes } from "utils/CommonConstants";
import Button from "./Button";

interface Props {
  getOnClickForCreatePlan: any;
  showDesktopView?: boolean;
  showMobileView?: boolean;
  sx?: any;
}

function CreatePlanButton(props: Props) {
  const { getOnClickForCreatePlan, sx } = props;
  const isAdmin = useAppSelector((state) => state.app.isAdmin);
  const isSmeUser = useAppSelector((state) => state.app.isSmeUser);
  const { isMobileScreen } = useContext(ThemeContext);

  const PlanButton = (
    <Button
      accessType={accessTypes.update}
      sx={{ ...sx, width: isMobileScreen ? "90%" : "auto" }}
      label={"Create New Plan"}
      onClick={getOnClickForCreatePlan}
    />
  );

  return (
    <>
      {!isAdmin &&
        !isSmeUser &&
        (!isMobileScreen ? (
          PlanButton
        ) : (
          <Box
            sx={{
              position: "sticky",
              bottom: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-evenly",
              padding: "24px 0px 24px 0px",
              marginX: "-16px",
              background: colors.Neutral.Neutral0
            }}
          >
            {PlanButton}
          </Box>
        ))}
    </>
  );
}

export default CreatePlanButton;
